import React from "react";

export default function ModalStartLocationFromQR({ name, onClose }) {
  return (
    <div className="relative">
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="flex flex-col h-[700px] w-[300px] relative items-center justify-center">
          <div className="bg-[#215732] rounded-t-[10px] w-full max-w-md mx-auto border-[8px] border-[#215732] h-[44px] flex flex-row items-center justify-center">
            <span className="text-white text-[18px]">Start Location</span>
          </div>
          <div className="bg-white px-5 w-full max-w-md py-4 flex flex-row items-center justify-center">
            <span className="text-black text-xs">
              Your start location is preset as <b>{name}</b>, based on the
              location of your scanned QR code. You can modify the location to
              your preference.
            </span>
          </div>
          <div
            onClick={onClose}
            className="bg-[#3BD224] rounded-b-[10px] py-2 w-full max-w-md mx-auto flex flex-row items-center justify-center"
          >
            <span className="text-white font-bold text-[18px]">
              I Understand
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
